import { render } from "./ChatSessionMessage.vue?vue&type=template&id=2c96b61f&scoped=true"
import script from "./_ChatSessionMessage.js?vue&type=script&lang=js"
export * from "./_ChatSessionMessage.js?vue&type=script&lang=js"

import "./_ChatSessionMessage.less?vue&type=style&index=0&id=2c96b61f&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c96b61f"]])

export default __exports__